import axios from "axios";

export default {
    get() {
        return axios.get("projects");
    },
    store(body) {
        return axios.post("projects", body);
    },
    clipStore(body) {
        return axios.post("projects/clips", body);
    },
    clipDelete(projectId, clipId) {
        return axios.delete(`projects/clips/${projectId}/${clipId}`);
    },
    userStore(body) {
        return axios.post("projects/users", body);
    }
};
